<template>
  <header class="simple-header">
    <NuxtLink to="/" external :title="content.logo_alt || false">
      <SvgIcon class="logo" name="domusvi-logo" />
    </NuxtLink>
  </header>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss">
body {
  --header-height: 52px;

  @include for-tablet-landscape-up {
    --header-height: 76px;
  }
}
body.header-absolute .simple-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
}

body.header-white .simple-header {
  background-color: var(--solid-07);
}
</style>
<style lang="scss" scoped>
.simple-header {
  z-index: $z-index-menu;
  max-width: $header-width;
  margin: 0 auto;
  background-color: var(--solid-05);
  border-radius: 0 0 $radius-xs $radius-xs;
  padding: 0.875rem 0;

  .logo {
    display: block;
    margin: 0 auto;
    height: 1.5rem;
    color: var(--brand);
  }

  @include for-tablet-landscape-up {
    border-radius: 0 0 $radius-s $radius-s;

    .logo {
      height: 3rem;
    }
  }
}
</style>
